import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SubcategoriesComponent } from './subcategories.component';
import { AddSubcategoriesComponent } from './add-subcategories/add-subcategories.component';
import { EditSubcategoriesComponent } from './edit-subcategories/edit-subcategories.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
    declarations: [
        SubcategoriesComponent,
        AddSubcategoriesComponent,
        EditSubcategoriesComponent
    ],
    imports: [
        CommonModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule
    ],
    exports: [
        SubcategoriesComponent
    ]
})
export class SubcategoriesModule { }
